import { Dialog } from '@/components/Dialog';
import { DialogActions } from '@/components/Elements/DialogActions';

interface ConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  messages: string[];
  confirmText: string;
  cancelText?: string;
  isConfirmDisabled?: boolean;
  isConfirmLoading?: boolean;
  confirmColor?: 'primary' | 'danger';
  maxWidth?: 'sm' | 'md' | 'lg';
}

export const ConfirmDialog = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  messages,
  confirmText,
  cancelText,
  isConfirmDisabled = false,
  isConfirmLoading = false,
  confirmColor = 'primary',
  maxWidth = 'md',
}: ConfirmDialogProps) => {
  return (
    <Dialog isOpen={isOpen} onClose={onClose} title={title} maxWidth={maxWidth}>
      <div className="space-y-4">
        <div className="space-y-2 text-sm">
          {messages.map((message, index) => (
            <p key={index}>{message}</p>
          ))}
        </div>

        <DialogActions
          onCancel={onClose}
          onConfirm={onConfirm}
          confirmText={confirmText}
          cancelText={cancelText}
          isConfirmDisabled={isConfirmDisabled}
          isConfirmLoading={isConfirmLoading}
          confirmColor={confirmColor}
        />
      </div>
    </Dialog>
  );
};
